import { ServerActionDefinition } from "components/actions/actions";
import { TableDefinition } from "./table";

export default class TableExport {

    private static readonly URL_FILTER_API = "/filter.json";

    public static renderExportActions(tableDefinition: TableDefinition, barDefinition) {
        if ((tableDefinition.exportConfigurations != null) &&
            ((tableDefinition.dataUrl) ||
                (tableDefinition.dataUrlBaseExport))) {
            for (let conf of tableDefinition.exportConfigurations) {
                if (conf.exportType === "csv") {
                    this.renderCsvButton(tableDefinition, barDefinition)
                } else if (conf.exportType === "excel") {
                    this.renderExcelButton(tableDefinition, barDefinition)
                }
            }
        }

        if ((tableDefinition.exportConfigurations != null) &&
            (!tableDefinition.dataUrl) &&
            (!tableDefinition.dataUrlBaseExport)) {
            console.warn("No url defined for export");
        }
    }

    private static renderCsvButton(tableDefinition: TableDefinition, barDefinition) {
        const urlApi = "/export.csv";
        let url = null;
        if (tableDefinition.dataUrlBaseExport) {
            url = tableDefinition.dataUrlBaseExport + urlApi
        } else {
            url = tableDefinition.dataUrl.replace(TableExport.URL_FILTER_API, urlApi);
        }
        let actionDefinition: ServerActionDefinition = {
            actionName: "export-csv",
            url,
            httpMethod: "GET",
            fieldParameterMappings: [],
            mapAll: false,
            successUpdatesParent: false,
        };
        barDefinition.children.push({
            componentType: "actionButton",
            id: "csv-export-" + tableDefinition.id,
            labelKey: "CSV",
            style: "default",
            iconFont: "fa-download",
            action: actionDefinition,
        });
    }

    private static renderExcelButton(tableDefinition: TableDefinition, barDefinition) {
        const urlApi = "/export.xlsx";
        let url = null;
        if (tableDefinition.dataUrlBaseExport) {
            url = tableDefinition.dataUrlBaseExport + urlApi
        } else {
            url = tableDefinition.dataUrl.replace(TableExport.URL_FILTER_API, urlApi);
        }
        let actionDefinition: ServerActionDefinition = {
            actionName: "export-excel",
            needsChange: false,
            needsValid: false,
            url,
            httpMethod: "GET",
            fieldParameterMappings: [],
            mapAll: false,
            successUpdatesParent: false,
        };
        barDefinition.children.push({
            componentType: "actionButton",
            id: "excel-export-" + tableDefinition.id,
            labelKey: "Excel",
            style: "default",
            iconFont: "fa-file-excel-o",
            action: actionDefinition,
        });
    }
}

export interface ExportConfiguration {
    exportType: string;
    enabled: boolean;
}
